import { ACTION } from './constants';
import request from '../../../../utils/request';
import { requestConfig } from '../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../actions';

export function getjanNivesh() {
    return dispatch => {
        return request(requestConfig.getjanNivesh())
            .then((json) => {
                json && dispatch({ type: ACTION.JAN_NIVESH, data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with jan nivesh data: " + error)
            });
    }
}
